// Invalid QR (route /invalid-qr) and catch-all for unknown routes.
import { t } from '../i18n'
import BrandLockup from '../components/BrandLockup'

const InvalidQr = () => {
  return (
    <div className="cf-page">
      <div className="cf-card">
        <BrandLockup />
        <div className="cf-icon">❌</div>
        <h1 className="cf-title">{t.invalidQrTitle}</h1>
        <p className="cf-subtitle">{t.invalidQrIntro}</p>
      </div>
    </div>
  )
}

export default InvalidQr
